import { Image } from '@tiptap/extension-image';
import { getNoticeImage } from 'apis/Service/ServiceBoard';

export const SecureImage = Image.extend({
    name: 'secureImage',
    
    addAttributes() {
        return {
            ...this.parent?.(),
            // imageId를 저장
            imageId: {
                default: null,
                parseHTML: element => element.getAttribute('data-image-id'),
                renderHTML: attributes => {
                    if (!attributes.imageId) {
                        return {};
                    }
                    return {
                        'data-image-id': attributes.imageId,
                    };
                },
            },
            // src는 임시로 유지 (에디터 내 미리보기용)
            src: {
                default: null,
                parseHTML: element => element.getAttribute('src'),
                renderHTML: attributes => {
                    if (!attributes.src) {
                        return {};
                    }
                    return {
                        src: attributes.src,
                    };
                },
            },
        };
    },

    addNodeView() {
        return ({ node, HTMLAttributes }) => {
            const dom = document.createElement('img');
            const imageId = node.attrs.imageId;
            const src = node.attrs.src;
            const state = { blobUrl: null }; // 객체로 관리하여 클로저 문제 해결

            // HTML 속성 적용
            Object.keys(HTMLAttributes).forEach(key => {
                dom.setAttribute(key, HTMLAttributes[key]);
            });

            // alt, title 속성 설정
            if (node.attrs.alt) {
                dom.alt = node.attrs.alt;
            }
            if (node.attrs.title) {
                dom.title = node.attrs.title;
            }

            // imageId가 있으면 API를 통해 이미지 가져오기
            if (imageId) {
                // 로딩 중 표시 (로딩 이미지 제거 - 빈 이미지로 시작)
                dom.src = '';
                dom.style.backgroundColor = '#f5f5f5';
                dom.style.minHeight = '200px';
                dom.style.display = 'block';
                
                getNoticeImage(imageId)
                    .then(blob => {
                        console.log('이미지 Blob 받음:', {
                            imageId,
                            blobSize: blob.size,
                            blobType: blob.type,
                            isBlob: blob instanceof Blob
                        });
                        
                        // Blob 유효성 검사
                        if (!blob || !(blob instanceof Blob)) {
                            throw new Error('Invalid blob response');
                        }
                        
                        // 기존 Blob URL 정리
                        if (state.blobUrl) {
                            URL.revokeObjectURL(state.blobUrl);
                            state.blobUrl = null;
                        }
                        
                        // Blob URL 생성
                        state.blobUrl = URL.createObjectURL(blob);
                        console.log('Blob URL 생성:', state.blobUrl);
                        
                        // 이미지 로드 성공 핸들러
                        dom.onload = () => {
                            console.log('이미지 로드 성공:', imageId);
                            dom.style.backgroundColor = '';
                            dom.style.minHeight = '';
                        };
                        
                        // 이미지 로드 에러 핸들러
                        dom.onerror = (e) => {
                            console.error('이미지 DOM 로드 실패:', {
                                imageId,
                                blobUrl: state.blobUrl,
                                error: e
                            });
                            // 에러 이미지 표시
                            dom.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2VlZSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiIGZpbGw9IiM5OTkiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj7slYzqs7XtlZg8L3RleHQ+PC9zdmc+';
                            dom.alt = '이미지를 불러올 수 없습니다';
                            dom.style.backgroundColor = '';
                            dom.style.minHeight = '';
                        };
                        
                        // src 설정 (이 시점에서 이미지 로드 시작)
                        dom.src = state.blobUrl;
                    })
                    .catch(error => {
                        console.error('이미지 API 호출 실패:', {
                            imageId,
                            error: error.message || error,
                            stack: error.stack,
                            response: error.response
                        });
                        // 에러 이미지 표시
                        dom.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2VlZSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiIGZpbGw9IiM5OTkiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj7slYzqs7XtlZg8L3RleHQ+PC9zdmc+';
                        dom.alt = '이미지를 불러올 수 없습니다';
                        dom.style.backgroundColor = '';
                        dom.style.minHeight = '';
                    });
            } else if (src) {
                // imageId가 없고 src만 있는 경우 (기존 방식 호환)
                dom.src = src;
            }

            return {
                dom,
                update: (updatedNode) => {
                    // 노드 업데이트 시 imageId 변경 확인
                    const newImageId = updatedNode.attrs.imageId;
                    if (newImageId !== imageId && newImageId) {
                        // imageId가 변경된 경우 다시 로드
                        dom.src = '';
                        dom.style.backgroundColor = '#f5f5f5';
                        getNoticeImage(newImageId)
                            .then(blob => {
                                if (state.blobUrl) {
                                    URL.revokeObjectURL(state.blobUrl);
                                }
                                state.blobUrl = URL.createObjectURL(blob);
                                dom.src = state.blobUrl;
                            })
                            .catch(error => {
                                console.error('이미지 업데이트 실패:', error);
                                dom.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2VlZSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiIGZpbGw9IiM5OTkiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj7slYzqs7XtlZg8L3RleHQ+PC9zdmc+';
                            });
                    }
                },
                destroy: () => {
                    // Blob URL 정리
                    if (state.blobUrl) {
                        URL.revokeObjectURL(state.blobUrl);
                        state.blobUrl = null;
                    }
                },
            };
        };
    },
});
